/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Markdown from 'bundles/cms/components/Markdown';

type Props = {
  content?: string | null;
};

const style = {
  content: () => css`
    .rc-Markdown.styled {
      margin-top: var(--cds-spacing-400);

      h3 {
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        margin: var(--cds-spacing-200) 0 0;
      }
    }
  `,
};

const AboutProfessionalCertsDescription: React.FC<Props> = ({ content }) => {
  return <div css={style.content}>{content && <Markdown source={content} />}</div>;
};

export default AboutProfessionalCertsDescription;
